import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ scope, startDate, endDate }) =>
    present(
      repository
        .getWeekTimeRecords(scope, startDate, endDate)
        .then((timeRecords) => ({ scope, startDate, endDate, timeRecords }))
        .catch(() => Promise.reject({ scope, startDate, endDate })),
    );
}

export type { Interactor };

export { createInteractor };
